exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listAreaContent[data-v-2e21b1c5] {\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-left: 1px;\n  scrollbar-width: none;\n}\n.listAreaContent[data-v-2e21b1c5]::-webkit-scrollbar {\n  width: 0;\n}\n", ""]);

// exports
